import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class IndexView extends JQueryView {
  constructor() {
    super('#notice');
  }

  // イベント毎の資金調達履歴と時価総額の推移の通知
  @on({ event: 'change', selector: '#notice_display_flag' })
  toggleNoticeDisplayFlag() {
    const hideNotice = $('#notice_display_flag').is(':checked');
    $.post(
      '/company/fund_procurement_histories/toggle_checked_fund_procurement_notice',
      {
        hide_notice: hideNotice,
      },
    );
  }

  @on({ event: 'click', selector: '#notice_close' })
  removeNotice() {
    $('#notice').remove();
  }
}
